<template>
  <section>
    <section class="page1">
      <article class="container">
        <wl-title class="h1" title='关于为乐' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="img"><img v-lazy="'/static/img/about/1-page1.png'" alt="关于为乐"></section>
          <p>{{page1Str1}}
            科研类实验室：<a href="/product/standard">高校实验室安全规范管理平台</a>、<a href="/product/synthetical">实验室综合管理平台</a>
            检测类实验室：<a href="/product/lims">实验室信息管理系统ProLIMS</a>
            SASS实验室：<a href="http://sj.weileit.com/#/login" target="_blank">试剂通</a> 
            {{page1Str3}}
          </p>
        </section>
        <section class="flex">
          <section class="box" v-for="(item,idx) in page1Data" :key="item.key">
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
            <section class="_icon " :style="`background-position: -${62*idx}px 0px;`"></section>
          </section>
        </section>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/about/1-page2-bg.png'">
      <article class="container">
        <wl-title title='完善的服务机制' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="fl_box" v-for="(item,idx) in page2Data" :key="item.key">
            <section class="_icon " :style="`background-position: -${92*idx}px -62px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <contact-page></contact-page>
    <submit-page></submit-page>
  </section>
</template>

<script>
import SubmitPage from '../../../components/submitPage.vue'
import contactPage from './contactPage.vue'
export default {
  components: { contactPage, SubmitPage },
  name: 'aboutCompany',
  data() {
    return {
      page1Str1: "为乐信息科技成立于2015年，是一家专注做实验室信息化解决方案的提供商，致力于为科研人员提供智能化一站式的科研管理解决方案。\n为乐信息科技一直围绕实验室的生态系统构建，经过多年的研发创新，拥有三大实验室产品线，包括",
      page1Str3: " 已实现实验室多方位、多层次、全流程的智慧实验管理模式，致力于发展成为实验室行业综合实力最强的信息化服务提供商！\n为乐信息科技目前已服务了300+高校、科研单位、医院、检测机构、企业等单位，实现实验室智能化、数字化、信息化管理， 让更多科研用户享受到更加便捷的科研管理环境，助力实验室更安全更规范、更智能的全面构建，让科研更简单更便捷！",
      page1Data: [
        { title: '愿景', desc: '成为实验室行业综合实力\n最强的信息化服务提供商', key: 'about1-1' },
        { title: '使命', desc: '让实验室更安全，更智能\n让科研更便捷', key: 'about1-2' },
        { title: '目标', desc: '为用户提供实验室\n全方位的解决方案', key: 'about1-3' },
      ],
      page2Data: [
        { title: '售前服务', desc: '专业的售前咨询\n精准的需求分析\n完整的解决方案', key: 'about1-4' },
        { title: '技术支持', desc: '7*24小时服务\n现场、电话、在线远程支持\n专人跟进，全程无忧\n定制开发，迭代升级', key: 'about1-5' },
        { title: '实施服务', desc: '系统使用培训\n项目一对一服务\n多年项目专家现场实施', key: 'about1-6' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/about/icon-sprite.png");
}
p {
  white-space: pre-line;
  font-size: 24px;
  color: #8e8e8e;
}
h3 {
  color: #262626;
}
.page1 {
  height: 1367px;
  padding-top: 136px;
  .h1 {
    padding-bottom: 65px;
  }
  .flexWrap {
    padding-bottom: 98px;
    a{
      text-decoration:underline;
    }
    .img {
      width: 627px;
    }
    p {
      font-size: 20px;
      text-align: left;
      width: 602px;
      color: #262626;
      line-height: 34px;
      margin-top: -7px;
      text-align: justify;
    }
  }
  .box {
    flex: 1;
    height: 456px;
    border-top: 1px solid #e1e1e1;
    padding-top: 90px;
    background: #fff;
    &:nth-child(2) {
      border: 1px solid #e1e1e1;
      border-bottom: none;
    }
    h3 {
      line-height: 36px;
      font-size: 36px;
      font-weight: bold;
    }
    p {
      padding-bottom: 76px;
      line-height: 40px;
      padding-top: 20px;
    }
  }
  ._icon {
    width: 62px;
    height: 62px;
    display: inline-block;
  }
}
.page2 {
  height: 773px;
  padding-top: 136px;
  ._icon {
    width: 92px;
    height: 92px;
    display: inline-block;
  }
  .flexWrap {
    margin-top: 55px;
    .fl_box {
      width: 360px;
      height: 400px;
      background: #ffffff;
      border-radius: 14px;
      padding-top: 50px;
      transition: all 0.2s linear;
      &:hover {
        transform: translateY(-10px);
      }
      h3 {
        line-height: 28px;
        font-size: 28px;
        font-weight: 500;
        padding-top: 13px;
        padding-bottom: 14px;
      }
      p {
        line-height: 40px;
      }
    }
  }
}
</style>
